import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import 'styles/reset.css';
import 'styles/bootstrapCustom';
import 'styles/global.scss';
import * as FontAwesome from 'styles/fontAwesomeIcons';
import { App } from './App';
import { preventI18nTreeShake } from 'i18n';

axios.defaults.baseURL = process.env.REACT_SERVER_BASE_URL_LOCAL

preventI18nTreeShake();
FontAwesome.init();

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('app')
);
